import React from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';
import logo_cube from '../assets/logo_cube.png';

const LoadingScreen = ({ containerStyle, type = 'fullscreen' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: type === 'section' ? 'rgba(255, 255, 255, 0.8)' : 'background.default',
        zIndex: type === 'section' ? 1 : 1000,
        ...(type === 'section' ? {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: 'inherit'
        } : containerStyle || {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        })
      }}
    >
      <motion.img
        src={logo_cube}
        alt="Loading..."
        initial={{ rotate: 0 }}
        animate={{ 
          rotate: 3600
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: [0.4, 0, 0.2, 1],
          repeatType: "loop"
        }}
        style={{
          width: type === 'section' ? '30px' : '50px',
          height: type === 'section' ? '39px' : '65px',
          transformOrigin: 'center',
          filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
        }}
      />
    </Box>
  );
};

export default LoadingScreen; 